import styled from 'styled-components';

export const Container = styled.div`
  ul {
    list-style: none;
    padding: 0;
  }

  ul.pagination li {
    display: inline-block;
    display: flex;
    justify-content: center;
    font-size: 25px;
  }

  ul.pagination li button {
    text-decoration: none;
    color: #337ab7;
    font-family: sans-serif;
    font-size: 0.9rem;
  }

  ul.pagination li.active button {
    color: white;
  }
  ul.pagination li.active {
    background-color: #007bff;
  }

  ul.pagination li button:hover,
  ul.pagination li button.active {
    color: #000000;
  }

  .pagination__item--active {
    background-color: #0069d9;
    border: none;
    color: #fff !important;
  }
`;
